import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const DrawModeIcon = React.memo<IconProps>(
  ({ className = '', size = 16, width, height, color = 'currentColor', onClick, strokeWidth = 1.5 }) => (
    <BaseIcon
      className={className}
      size={size}
      width={width}
      height={height}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      {/* 3D space grid hint (perspective lines) */}
      <path
        d="M3 18L12 12M21 18L12 12M12 12V4"
        stroke={color}
        strokeWidth={strokeWidth * 0.6}
        strokeLinecap="round"
        opacity="0.3"
      />
      {/* 3D floating stroke in space */}
      <path
        d="M6 8c3 2 6 6 12 2"
        stroke={color}
        strokeWidth={strokeWidth * 1.3}
        strokeLinecap="round"
        fill="none"
      />
      {/* Second stroke showing depth */}
      <path
        d="M8 14c2 1 5 3 9 1"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
      {/* Pen cursor at end of stroke */}
      <circle cx="18" cy="10" r="1.5" fill={color} />
      <path d="M18 7v1.5M18 11.5v1.5" stroke={color} strokeWidth={strokeWidth * 0.7} strokeLinecap="round" />
    </BaseIcon>
  ),
);

DrawModeIcon.displayName = 'DrawModeIcon';
